module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/join/step-screen-4-9c704cbe298aa603b3efa8e47010d180.png";